import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appNumericInput]',
})
export class NumericInputDirective {
  @Input() max: number | undefined; // Maximum value allowed

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    const inputElement = this.el.nativeElement;
    const value = inputElement.value;

    // Allow special keys like Backspace, Delete, Arrow keys, etc.
    if (
      ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(
        event.key
      )
    ) {
      return;
    }

    // Prevent input if value exceeds max
    const newValue = value + event.key;
    if (this.max !== undefined && +newValue > this.max) {
      event.preventDefault(); // Block the keypress
    }

    // Allow only numbers
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault(); // Block non-numeric input
    }
  }
}
